import React, {Component} from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin'
import {getRequest, obj2params} from '../../util/utils';

class PopUp extends Component {

    constructor(props, context) {
        super(props, context);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.jumpToSeatButton = this.jumpToSeatButton.bind(this);
        this.undoBg = this.undoBg.bind(this);
    }

    jumpToSeatButton() {
        // console.log('PopUp to bookdetail == ', this.props.searchInfo);
        this.props.history.push({
            pathname: '/bookDetail?' + obj2params(getRequest()),
            state: this.props.searchInfo
        });
    }

    undoBg() {
        let actions = this.props.actions;
        let data = Object.assign({}, this.props.searchInfo, {bookAddressStyle: {display: 'none'}});
        actions.undoBg(data)
    }

    render() {
        let bookAddressStyle = this.props.searchInfo.bookAddressStyle;
        let positionInfos = this.props.searchInfo.bookPosition;
        let clickBook = this.props.searchInfo.clickBook || {};

        let isInStore = "其它";
        if (clickBook.data1 === "1") {
            isInStore = "未借出"
        } else if (clickBook.data1 === "2") {
            isInStore = "已借出"
        } else if (clickBook.data1 === "100") {
            isInStore = "其它";
        }
        // if(positionInfos.length === 1){
       /* if(true){
            console.log("tap");
            this.jumpToSeatButton;

        }*/
        // console.log('bookAddressStyle',bookAddressStyle);

        return (


            <div style={bookAddressStyle}>
                <div className="blackBg" onClick={this.undoBg}/>
                <div className="popUp">
                    <h2>图书位置</h2>
                    <div className="popUp-main">
                        <table width="100%" className="popUpTable" cellSpacing="0">
                            <thead>
                            <tr>
                                <th>文献地点</th>
                                <th>条码号(卷次)</th>
                                <th>是否在架</th>
                                <th>是否借出</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                positionInfos.map((position, index) => {
                                    // noinspection JSUnresolvedVariable
                                    return (
                                        <tr key={index}>
                                            <td>{position.shelf_mark}</td>
                                            <td>{position.book_barcode}</td>
                                            <td>是</td>
                                            <td>{isInStore}</td>
                                        </tr>
                                    )
                                })
                            }
                            {
                                positionInfos.length === 0 ?
                                    <tr>
                                        <td/>
                                        <td>{clickBook.book_barcode}</td>
                                        <td>否</td>
                                        <td>{isInStore}</td>

                                    </tr>
                                    : ""

                            }
                            </tbody>
                        </table>
                    </div>

                    <div className="popUp-foot tc">
                        {
                            positionInfos.length === 0 ? "" :
                                <button onClick={this.jumpToSeatButton} className="btn3"
                                        type="button">查看所有图书位置
                                </button>
                        }
                    </div>


                </div>
            </div>
        )

    }
}

export default PopUp;



// WEBPACK FOOTER //
// ./src/components/home/PopUp.js